import { featureCollection } from '@/constants/index';
import type { FeaturesLocation } from '@/types/overlays';

export const getCustomPropertyForGeojson = (
  geojson: FeaturesLocation | undefined,
  targetProperty: string
): string | number[] | undefined => {
  if (!geojson) return;
  if (geojson.type === featureCollection) {
    for (const feature of geojson.features) {
      if (feature.properties?.[targetProperty] !== undefined) {
        return feature.properties[targetProperty];
      }
    }
  }

  return undefined;
};
